/* eslint-disable react/react-in-jsx-scope */
const Check = () => {
    return (
        <div>
            <label>Checking...</label>
        </div>
    )
}

export default Check
